import axios from 'axios'

const API_PREFIX = 'pedidos/satisfaccion'

export default {
    consultarSatisfaccionGlobal: params => axios(`${API_PREFIX}/listado-satisfaccion`,{params}),
    consultarSatisfaccionAnual: params => axios(`${API_PREFIX}/listado-satisfaccion-anual`, { params }),
    consultarSatisfaccionMensual: params => axios(`${API_PREFIX}/listado-satisfaccion-mensual`, { params }),
}
